module.exports = __webpack_public_path__ + "img/yundong_3.6655f9f4.png";